export const DEMO_ID = "690";
export const MOVIE_PATH = `https://api.themoviedb.org/3/movie/${DEMO_ID}?api_key=09556e4c4359b6d0176d300a95fe9d33`;
export const POSTER_PATH_BASE = "https://image.tmdb.org/t/p/w200";
export const API_KEY = "09556e4c4359b6d0176d300a95fe9d33";
export const BACKEND = "https://moviedb-ptv8.onrender.com/api/movies";
// export const BACKEND = "http://localhost:8080/api/movies";